module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/footer_bubble-91b4a07168d502837f932a4ef88a81aa.png";